"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "./theme-provider";
import { Toaster } from "./ui/sonner";
import { PostHogProvider } from "./posthog-provider";
import { useEffect } from "react";

interface ProvidersProps {
  children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  useEffect(() => {
    // Listener para mensagens do service worker (navegação via push notification e som)
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const handleMessage = (event: MessageEvent) => {
        if (event.data?.type === "navigate" && event.data?.url) {
          window.location.href = event.data.url;
        } else if (event.data?.type === "playNotificationSound" && event.data?.soundUrl) {
          // Tocar o som da notificação quando a página estiver aberta
          try {
            const audio = new Audio(event.data.soundUrl);
            audio.volume = 0.7; // Volume moderado
            audio.play().catch((err) => {
              // Alguns navegadores requerem interação do usuário antes de tocar áudio
              // Se falhar, apenas logar - não é crítico
              console.log("Não foi possível tocar o som automaticamente:", err);
            });
          } catch (err) {
            console.log("Erro ao criar elemento de áudio:", err);
          }
        }
      };

      navigator.serviceWorker.addEventListener("message", handleMessage);

      return () => {
        navigator.serviceWorker.removeEventListener("message", handleMessage);
      };
    }
  }, []);

  return (
    <PostHogProvider>
      <SessionProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          {children}
          <Toaster richColors closeButton position="top-center" />
        </ThemeProvider>
      </SessionProvider>
    </PostHogProvider>
  );
}
